(function(){
  /* ------------------------------------------------------------------
     ONE shared script for every ALUMA advertorial.

     Two modes:
       legacy  - the pages that exist today. 3 bundles, one-time OR Seal
                 subscription toggle, two ₪0 gift accessories. Untouched.
       sub99   - the subscription-only test (Sept 2026). Enabled ONLY when
                 the page template placed the "ALUMA sub-only offer" config
                 section BEFORE the advertorial section, which defines
                 window.ALUMA_OFFER. Old pages never define it, so they
                 keep running the legacy branch byte-for-byte.

     sub99 rules (from Itay, 2026-09-04):
       - 1 bag ₪99 / 2 bags ₪189, no 3-bag tier
       - no gift accessories
       - subscription only - no toggle, just small print under the picker
       - one small link "לרכישה ללא מנוי במחיר מלא" -> the original page
     The selling-plan ids + real per-delivery prices are READ from the sub
     product's own /products/<handle>.js at load, so Seal can be changed
     without touching this file. The config numbers are only a fallback
     for the first paint before that fetch resolves.
     ------------------------------------------------------------------ */
  var OFFER = window.ALUMA_OFFER || null;
  var SUB99 = !!(OFFER && OFFER.mode === 'sub99');

  /* Seal Subscriptions plans, read back from the live store. These `unit`
     numbers are FIXED PRICES set inside Seal - the page only mirrors them.
     If they drift, the card price and the checkout price disagree and she
     bounces at payment. Never edit one side alone.

     2026-08-03: Seal moved from 15% to 10%. Units updated to match:
     161.40->170.91, 118.95->125.95, 96.30->101.97. Everything downstream
     (card price, saving, headline %, topbar claim) derives from these. */
  var SUB = {
    1: { plan: 691750076708, unit: 170.91 },   // ships monthly
    2: { plan: 691750240548, unit: 125.95 },   // ships every 2 months
    3: { plan: 691750273316, unit: 101.97 }    // ships every 3 months
  };
  var B = {
    1: { price:189.90, compare:249.90 },
    2: { price:279.90, compare:499.80 },
    3: { price:339.90, compare:749.70 }
  };
  /* The "+ אקססוריז מתנה" the cards promise. Both ₪0.00, one of each per
     order regardless of bundle size, and deliberately WITHOUT a selling_plan -
     a subscriber needs one spoon, not a new one every month. Verified they do
     not push the cart up an automatic quantity-discount bracket. */
  var GIFTS = [
    { id: 52787697156388, quantity: 1 },   // כפית מדידה Aluma
    { id: 52787696763172, quantity: 1 }    // מקציף חלב Aluma
  ];
  var COPY = {
    on:  { t: 'משלוח עד הבית חינם 🚚', s: 'מנוי מתחדש · בלי התחייבות · ביטול בכל עת' },
    off: { t: 'משלוח לנקודת איסוף',     s: 'רכישה חד־פעמית, בלי מנוי' }
  };

  if(SUB99){
    /* Rebuild the two tables from the config. `unit` is per bag, so tier 2
       at ₪189 is ₪94.50 a bag - what Seal's 2-month rule must charge. */
    var T = OFFER.tiers || {};
    SUB = {}; B = {};
    Object.keys(T).forEach(function(k){
      var q = parseInt(k,10), t = T[k];
      SUB[q] = { plan: t.plan || null, unit: t.price / q };
      B[q]   = { price: t.price, compare: t.compare || (OFFER.unit_compare || 249.90) * q };
    });
    GIFTS = [];
  }

  var H = {'Content-Type':'application/json'};
  var root = document.getElementById('av-bundles');
  if(!root) return;
  var cards    = Array.prototype.slice.call(root.querySelectorAll('.av-bundle'));
  var orderBtn = document.getElementById('av-orderbtn');
  var subrow   = document.getElementById('av-subrow');
  var subTitle = subrow.querySelector('.av-st');
  var subDesc  = subrow.querySelector('.av-sd');
  var subOn    = true;
  var busy     = false;   // one checkout chain at a time
  var addedOnce = false;  // whether THIS page load already put items in the cart
  /* Hebrew has no neutral second person, so the saving line has to be gendered.
     The women's pages say חסכי and leave the attribute off; the men's page sets
     data-save="חסכת" on #av-bundles. Reading it here keeps ONE shared file
     serving every advertorial instead of forking the script per audience. */
  var saveVerb = root.getAttribute('data-save') || 'חסכי';
  var shipChip = (function(){
    var chips = document.querySelectorAll('.av-trustline span');
    for(var i=0;i<chips.length;i++){
      if(chips[i].textContent.indexOf('משלוח') > -1) return chips[i];
    }
    return null;
  })();
  var ils = function(n){
    return '₪' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* ---- sub99: reshape the markup the section shipped -------------------
     The advertorial sections are shared with the legacy pages, so the
     3-card / gift-line HTML arrives as-is and is trimmed here. */
  if(SUB99){
    cards = cards.filter(function(card){
      var q = parseInt(card.getAttribute('data-qty'),10);
      if(B[q]) return true;
      card.parentNode.removeChild(card);
      return false;
    });
    /* nothing selected any more (tier 3 was the default on some pages)?
       fall back to the biggest remaining bundle */
    if(!cards.some(function(c){ return c.classList.contains('av-is-sel'); }) && cards.length){
      cards[cards.length-1].classList.add('av-is-sel');
    }
    Array.prototype.slice.call(root.querySelectorAll('.av-gift')).forEach(function(g){
      g.parentNode.removeChild(g);
    });
    /* header wording comes from the config ("שקית אחת בחודש" / "2 שקיות בחודש") -
       the shipped markup says חודשיים / דו־חודשי, which is no longer true */
    cards.forEach(function(card){
      var q = parseInt(card.getAttribute('data-qty'),10);
      var hdr = card.querySelector('.av-hdr');
      var lbl = OFFER.labels && OFFER.labels[q];
      if(hdr && lbl){
        var small = hdr.querySelector('small');
        hdr.textContent = '';
        hdr.appendChild(document.createTextNode(lbl));
        if(small) hdr.appendChild(small); else hdr.appendChild(document.createElement('small'));
      }
      var img = card.querySelector('.av-pic img');
      if(img && lbl) img.alt = lbl;
    });
    root.style.setProperty('grid-template-columns', 'repeat(' + cards.length + ',1fr)', 'important');
    root.style.setProperty('max-width', cards.length === 2 ? '640px' : '', 'important');
    root.style.setProperty('margin', '0 auto', 'important');
    /* the picker row becomes a non-interactive note - subscription is the
       only way to buy on this page, there is nothing to toggle */
    subrow.classList.add('av-on', 'av-subnote');
    subrow.removeAttribute('role');
    subrow.removeAttribute('tabindex');
    subrow.setAttribute('aria-hidden', 'false');
    subrow.style.cursor = 'default';
    /* the note moves from above the cards to right under the order button
       (Itay 2026-09-05), and the small full-price link goes under the note */
    if(orderBtn){
      orderBtn.parentNode.insertBefore(subrow, orderBtn.nextSibling);
      if(OFFER.full_url){
        var a = document.createElement('a');
        a.className = 'av-fullprice';
        a.href = OFFER.full_url;
        a.textContent = OFFER.link_text || 'לרכישה ללא מנוי במחיר מלא';
        subrow.parentNode.insertBefore(a, subrow.nextSibling);
      }
    }
  }

  /* ---- legacy pages: new tier names (Itay 2026-09-15) -------------------
     The section HTML still says חודש אחד / חודשיים / שלושה חודשים (or the
     מארז חודשי variants). Every tier now ships MONTHLY, so the names describe
     the pack size instead: מארז יחיד / כפול / משולש. Rewritten here so the 7
     section files stay untouched. The % line inside <small> is kept. */
  var LEGACY_LABELS = { 1: 'מארז יחיד', 2: 'מארז כפול', 3: 'מארז משולש' };
  if(!SUB99){
    cards.forEach(function(card){
      var q = parseInt(card.getAttribute('data-qty'),10);
      var hdr = card.querySelector('.av-hdr');
      var lbl = LEGACY_LABELS[q];
      if(hdr && lbl){
        var small = hdr.querySelector('small');
        hdr.textContent = '';
        hdr.appendChild(document.createTextNode(lbl));
        if(small) hdr.appendChild(small); else hdr.appendChild(document.createElement('small'));
      }
      var img = card.querySelector('.av-pic img');
      if(img && lbl) img.alt = lbl;
    });
  }

  /* ---- Bundle selection ------------------------------------------------
     Painted as INLINE STYLE, and with NO transition. Both are deliberate.

     aluma-adv.css ships unselected cards at #6B4A36 and selected at #7B3D28 -
     two dark browns three shades apart, so which bundle was chosen was nearly
     invisible. Fixing it from an injected <style> lost twice: the sections
     link aluma-adv.css from the BODY, so it outranks anything appended to
     <head>. Inline style sits above all of it.

     And no transition, because a transitioned property here gets stuck at its
     pre-transition value - border-color and opacity kept reporting the state
     from the PREVIOUS selection while transform and the header updated fine.
     Dropping the transition made both apply instantly and correctly. An
     instant switch is right for a picker anyway; there is nothing to animate.

     Five signals change at once so the choice reads at a glance: border colour
     AND weight, opacity, elevation, header darkness, and a tick.
     -------------------------------------------------------------------- */
  function paint(card, on){
    card.style.removeProperty('transition');
    card.style.setProperty('border-color', on ? '#7B3D28' : '#DED2C2', 'important');
    card.style.setProperty('opacity',      on ? '1' : '0.58',          'important');
    card.style.setProperty('transform',    on ? 'translateY(-7px)' : 'none', 'important');
    card.style.setProperty('box-shadow',   on ? '0 14px 32px rgba(123,61,40,.42)' : 'none', 'important');
    if(on) card.style.setProperty('border-width', '4px', 'important');
    else   card.style.removeProperty('border-width');
    var hdr = card.querySelector('.av-hdr');
    if(hdr){
      hdr.style.setProperty('background', on ? '#3E2A1F' : '#A28D78', 'important');
      var tick = hdr.querySelector('.av-tick');
      if(on && !tick){
        tick = document.createElement('span');
        tick.className = 'av-tick';
        tick.textContent = '✓ ';
        hdr.insertBefore(tick, hdr.firstChild);
      } else if(!on && tick){
        tick.parentNode.removeChild(tick);
      }
    }
    var badge = card.querySelector('.av-badge');
    if(badge) badge.style.setProperty('background', on ? '#7B3D28' : '#A28D78', 'important');
  }
  function injectStyles(){
    var st = document.createElement('style');
    st.textContent =
      '.aluma-adv .av-deadline b{direction:ltr;unicode-bidi:isolate;display:inline-block;' +
      'font-variant-numeric:tabular-nums;font-weight:800;letter-spacing:.5px}';
    document.head.appendChild(st);
  }
  function selectedQty(){
    var card = root.querySelector('.av-bundle.av-is-sel');
    return card ? parseInt(card.getAttribute('data-qty'),10) : 1;
  }
  /* sub99 small print. Three ticked lines, RYZE-style, that re-read for the
     bundle she has selected: the price and the next-shipment date change,
     the cancel line does not. */
  function renderSubNote(){
    var q = selectedQty();
    var t = OFFER.tiers[q] || OFFER.tiers[1];
    var months = 30;   // every bundle ships monthly - 2 bags = 2 bags a month
    var lines = (OFFER.lines || []).map(function(l){
      return l.replace('{price}', ils(SUB[q].unit * q).replace('.00',''))
              .replace('{days}', String(months))
              .replace('{qty}', String(q));
    });
    subrow.innerHTML = lines.map(function(l){
      return '<div class="av-subline"><span class="av-chk" aria-hidden="true">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
        '</span><span class="av-sl">' + l + '</span></div>';
    }).join('');
    if(shipChip) shipChip.textContent = '🚚 משלוח עד הבית חינם';
    void t;
  }
  function render(){
    cards.forEach(function(card){
      var qty = parseInt(card.getAttribute('data-qty'),10);
      var b   = B[qty]; if(!b) return;
      var now = subOn ? SUB[qty].unit * qty : b.price;
      card.querySelector('.av-now').textContent  = ils(now);
      card.querySelector('.av-was').textContent  = ils(b.compare);
      card.querySelector('.av-save').textContent = saveVerb + ' ' + ils(b.compare - now);
      /* headline % is derived, never hand-typed - it has to survive the toggle */
      card.querySelector('.av-hdr small').textContent =
        Math.round((1 - now / b.compare) * 100) + '% הנחה';
    });
    if(SUB99){ renderSubNote(); return; }
    var c = subOn ? COPY.on : COPY.off;
    subTitle.textContent = c.t;
    subDesc.textContent  = c.s;
    if(shipChip) shipChip.textContent = subOn ? '🚚 משלוח עד הבית חינם' : '📦 משלוח לנקודת איסוף';
    subrow.classList.toggle('av-on', subOn);
    subrow.setAttribute('aria-checked', subOn ? 'true' : 'false');
  }
  /* The topbar and CTAs quote a best-case discount. Derived from the same table
     that prices the cards so the claim cannot drift from what checkout charges. */
  function syncMaxClaim(){
    var best = 0;
    Object.keys(SUB).forEach(function(k){
      var q = parseInt(k,10);
      var d = 1 - (SUB[q].unit * q) / B[q].compare;
      if(d > best) best = d;
    });
    var pct = Math.round(best * 100) + '%';
    document.querySelectorAll('.aluma-adv .av-topbar b, .aluma-adv .av-cta')
      .forEach(function(el){
        el.innerHTML = el.innerHTML.replace(/\d+%/g, pct);
      });
  }
  function select(card){
    cards.forEach(function(c){
      var on = (c === card);
      c.classList.toggle('av-is-sel', on);
      c.setAttribute('aria-selected', on ? 'true' : 'false');
      paint(c, on);
    });
    if(SUB99) renderSubNote();
  }
  cards.forEach(function(card){
    card.addEventListener('click', function(e){
      if(e.target.closest('select')) return;
      select(card);
      if(e.target.closest('.av-atc')) checkout();
    });
  });
  function toggleSub(){ subOn = !subOn; render(); }
  if(!SUB99){
    subrow.addEventListener('click', toggleSub);
    subrow.addEventListener('keydown', function(e){
      if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); toggleSub(); }
    });
  }
  /* Counts to 23:59:59 in HER timezone, which is what every CTA already
     promises. Digits are isolated LTR - a bare HH:MM:SS inside RTL reorders. */
  function startCountdown(){
    var el = document.querySelector('.av-deadline');
    if(!el) return;
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var s   = Math.max(0, Math.floor((end - now) / 1000));
      el.innerHTML = 'ההנחה שלך נשמרת עוד <b>' +
        pad(Math.floor(s / 3600)) + ':' +
        pad(Math.floor((s % 3600) / 60)) + ':' +
        pad(s % 60) + '</b>';
    }
    tick();
    setInterval(tick, 1000);
  }
  function clearCart(){ return fetch('/cart/clear.js', {method:'POST', headers:H}); }
  function addItems(items){
    return fetch('/cart/add.js', {
      method:'POST', headers:H, body:JSON.stringify({items:items})
    });
  }
  /* ---- Why the cart flow is more careful than it looks -----------------
     Shopify runs a bot filter in front of the cart endpoints. It counts POSTs,
     and once tripped it answers 429/430 with a "Verifying your connection"
     HTML page instead of JSON. The old flow fired clear+add on EVERY click,
     so a shopper who clicked twice - or tapped once on a slow phone and tapped
     again - burned four POSTs and got a generic error alert on a working cart.

     Three changes:
       1. `busy` guard, so a double tap cannot start a second chain.
       2. Clear only when it is actually needed. On a landing page arrived at
          from an ad the cart is nearly always empty, and a GET /cart.js is not
          on the throttled path - so the common case is now ONE POST, not two.
       3. A throttled add waits and retries instead of surfacing as an error.
     -------------------------------------------------------------------- */
  function ensureEmpty(){
    if(addedOnce) return clearCart();
    return fetch('/cart.js', {headers:H})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){ return (c && c.item_count > 0) ? clearCart() : null; })
      .catch(function(){ return null; });
  }
  function addWithRetry(items, tries){
    return addItems(items).then(function(r){
      if(r.ok) return r;
      if((r.status === 429 || r.status === 430) && tries > 0){
        return new Promise(function(res){ setTimeout(res, 1600); })
          .then(function(){ return addWithRetry(items, tries - 1); });
      }
      return r;
    });
  }
  /* Build the cart silently, then land on /checkout.
     The shopper never sees a cart page or drawer. */
  function checkout(){
    if(busy) return;
    var card = root.querySelector('.av-bundle.av-is-sel');
    if(!card){ alert('בחר חבילה'); return; }
    var qty  = parseInt(card.getAttribute('data-qty'),10);
    var plan = subOn ? SUB[qty].plan : null;
    if(SUB99 && !plan){
      /* Seal rule for this bundle is not attached to the sub product yet.
         Refuse rather than silently sell a one-time bag at full price. */
      alert('המנוי לחבילה הזו עדיין לא פעיל. נסי שוב בעוד רגע.');
      return;
    }
    var items = [];
    card.querySelectorAll('select').forEach(function(s){
      var it = { id: parseInt(s.value,10), quantity: 1 };
      if(plan) it.selling_plan = plan;
      items.push(it);
    });
    busy = true;
    var label = orderBtn.textContent;
    orderBtn.disabled = true;
    orderBtn.textContent = 'מעבירים לתשלום...';
    ensureEmpty()
      .then(function(){ return addWithRetry(items.concat(GIFTS), 2); })
      .then(function(r){
        if(r.ok) return r;
        /* Both gifts are stock-tracked with DENY. If they run dry the add 422s,
           and without this a freebie would take the whole sale with it. */
        return addWithRetry(items, 1);
      })
      .then(function(r){ if(!r.ok) throw new Error('add failed ' + r.status); return r.json(); })
      .then(function(){
        addedOnce = true;
        window.location.href = '/checkout';
      })
      .catch(function(){
        busy = false;
        orderBtn.disabled = false;
        orderBtn.textContent = label;
        alert('רגע אחד ונסה שוב');
      });
  }
  orderBtn.addEventListener('click', checkout);

  /* ---- sub99: bind the cards to the SUB product ------------------------
     The section HTML carries the legacy product's variant ids in every
     <select>. Swap them for the sub product's variants (matched by flavour
     name), and pull the selling plans Seal attached to it. BOTH plans are
     monthly; they differ only in the fixed per-bag price - the dearer one
     (₪99) prices the 1-bag card, the cheaper one (₪94.50) the 2-bag card.
     With a single plan attached, both cards use it. Prices come from
     per_delivery_price so a Seal edit shows up here with no code change. */
  function bindSubProduct(){
    if(!OFFER.product) return;
    var norm = function(s){ return String(s).replace(/[’'׳`]/g, '').replace(/\s+/g,'').trim(); };
    fetch('/products/' + OFFER.product + '.js', {headers:H})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if(!p) return;
        var byTitle = {};
        p.variants.forEach(function(v){ byTitle[norm(v.title)] = v; });
        root.querySelectorAll('select option').forEach(function(o){
          var v = byTitle[norm(o.textContent)];
          if(v) o.value = v.id;
        });
        var alloc = ((p.variants[0] && p.variants[0].selling_plan_allocations) || [])
          .filter(function(a){ return a.per_delivery_price; })
          .sort(function(a, b){ return b.per_delivery_price - a.per_delivery_price; });
        if(alloc.length){
          var hi = alloc[0], lo = alloc[alloc.length - 1];
          if(SUB[1]){ SUB[1].plan = hi.selling_plan_id; SUB[1].unit = hi.per_delivery_price / 100; }
          if(SUB[2]){ SUB[2].plan = lo.selling_plan_id; SUB[2].unit = lo.per_delivery_price / 100; }
        }
        render();
        syncMaxClaim();
      })
      .catch(function(){});
  }

  /* ---- legacy pages: adopt the MONTHLY Seal rules --------------------------
     2026-09-15: every tier ships monthly. The rules are shared by all four
     products, so mushroom-coffee.js is a fine source for every page. Only
     plans whose delivery option reads "לחודש"/"חודש" (not חודשיים / 3) count;
     if exactly three exist they price tiers 1-3 by per-bag price, dearest
     first. Anything else (rules not created yet, old rules still attached
     alongside) leaves the hardcoded table alone, so nothing breaks mid-change.
     The table below MUST still be updated once the new rules are final. */
  function bindLegacyPlans(){
    fetch('/products/mushroom-coffee.js', {headers:H})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if(!p || !p.variants || !p.variants[0]) return;
        var monthly = {};
        (p.selling_plan_groups || []).forEach(function(g){
          (g.selling_plans || []).forEach(function(sp){
            var txt = (sp.options || []).map(function(o){ return o.value; }).join(' ') + ' ' + sp.name;
            var isMonthly = /חודש/.test(txt) && !/חודשיים|2 חודש|3 חודש|שלוש|ל-2|ל-3/.test(txt);
            if(isMonthly) monthly[sp.id] = true;
          });
        });
        var alloc = p.variants[0].selling_plan_allocations
          .filter(function(a){ return monthly[a.selling_plan_id] && a.per_delivery_price; })
          .sort(function(a, b){ return b.per_delivery_price - a.per_delivery_price; });
        if(alloc.length !== 3) return;
        [1,2,3].forEach(function(q, i){
          SUB[q] = { plan: alloc[i].selling_plan_id, unit: alloc[i].per_delivery_price / 100 };
        });
        render();
        syncMaxClaim();
      })
      .catch(function(){});
  }

  injectStyles();
  cards.forEach(function(c){ paint(c, c.classList.contains('av-is-sel')); });
  render();
  syncMaxClaim();
  startCountdown();
  if(SUB99) bindSubProduct(); else bindLegacyPlans();
})();
